import { jsx as _jsx } from "react/jsx-runtime";
import classNames from '../../utils/classNames';
import styles from './TextCircle.module.css';
export const TextCircle = ({ children, title, onClick, size = 30, extraClassNames = [], }) => (_jsx("div", Object.assign({ className: classNames(styles.root, onClick ? styles.clickable : '', ...extraClassNames), title: title, onClick: onClick, style: { width: `${size}px`, height: `${size}px`, lineHeight: `${size}px` } }, { children: children }), void 0));
export default TextCircle;
